/**
 * A tiny shared store for the "opens in a pop-up" links (currently: any Zeffy donation
 * link). One <PopupFrame/> is mounted once, near the top of the page; any <SmartLink/>
 * whose address matches opens it instead of navigating away. Not React context, so a
 * link deep in the tree doesn't need a provider between it and the root.
 */

/** URL patterns that should open in the in-page pop-up instead of leaving the site. */
const POPUP_PATTERNS = [/\bzeffy\.com\b/i];

export const isPopupLink = (url) => POPUP_PATTERNS.some((re) => re.test(url || ''));

let current = null;
const listeners = new Set();

export function openPopup(url, label) {
  current = { url, label };
  listeners.forEach((fn) => fn(current));
}
export function closePopup() {
  current = null;
  listeners.forEach((fn) => fn(current));
}
export function subscribePopup(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
